import gql from 'graphql-tag';

export const getSubPlan = gql`
query getSubPlan($id: uuid!){
    subscription_plans_by_pk(id:$id){
    id
    updated_at
    name
    price_in_aud
    price_in_usd
    tenure_in_days
    tenure_type
    terms_and_conditions
    type
    description
    benefits


  }
}
`;


export const updateClientStatus = gql`mutation updateClientStatus($id: uuid! ,$clientStatus: clients_set_input!){
  update_clients_by_pk(pk_columns:{id: $id}, _set: $clientStatus){
    id
  }
}`;
